module.exports = __webpack_public_path__ + "static/media/text.423073bb.png";